import React from 'react';
import shallowCompare from '../../lib/shallowCompare';
import styles from './index.sass';
import appStoreBadgePng from './images/apple_app_store_2x.png';
import appStoreBadgeSvg from './images/apple_app_store.svg';
import playStoreBadgePng from './images/en-play-badge.png';

const PlayStoreLink = 'https://play.google.com/store/apps/details?id=com.delectable.market&hl=en';
const AppStoreLink = 'https://itunes.apple.com/us/app/banquet-shop-top-wine-stores/id1058119446?mt=8';

class AppStoreBadges extends React.Component {
  static propTypes = {
    className: React.PropTypes.string,
    appStoreLink: React.PropTypes.string,
    playStoreLink: React.PropTypes.string
  };

  static defaultProps = {
    className: '',
    appStoreLink: AppStoreLink,
    playStoreLink: PlayStoreLink
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    return (
      <div className={`${styles.downloadButtonsContainer} ${this.props.className}`}>
        <a className={styles.appStoreLink} href={this.props.appStoreLink}>
          <img src={appStoreBadgePng} srcSet={appStoreBadgeSvg} alt="Download Banquet on the App Store" />
        </a>
        <a className={styles.googlePlayLink} href={this.props.playStoreLink}>
          <img src={playStoreBadgePng} alt="Download Banquet on the Google Play" />
        </a>
      </div>
    );
  }
}

export default AppStoreBadges;



// WEBPACK FOOTER //
// banquet/components/AppStoreBadges/index.js